import { Component, OnInit, Input, SimpleChanges, OnChanges, ViewEncapsulation } from '@angular/core';
import { TopicLeaf } from '../../model/TopicLeaf';
import { globals } from '../shared/globals';
import { SafeStyle, DomSanitizer } from '@angular/platform-browser';
import { LazyImagesComponent } from '../shared/lazy-images-component';

@Component({
  selector: 'app-display-topic',
  templateUrl: './display-topic.component.html',
  styleUrls: ['./display-topic.component.css'],
  encapsulation: ViewEncapsulation.None
})

export class DisplayTopicComponent extends LazyImagesComponent implements OnChanges, OnInit {
  @Input() topic: TopicLeaf;
  @Input() area: string;

  private justTheUrl: string;
  public imgUrl: SafeStyle;

  ngOnChanges(changes: SimpleChanges) {
    let stringVersion = JSON.stringify(changes.topic.currentValue);
    let parsed = JSON.parse(stringVersion);

    if (!parsed.ThumbnailFileName) {
      return;
    }
    this.justTheUrl = '/assets/databaseimages/' + parsed.ThumbnailFileName;
    //      this.justTheUrl = globals.REMOTEHOST + '/assets/databaseimages/' + parsed.ThumbnailFileName;
    this.imgUrl = this.sanitizer.bypassSecurityTrustStyle("url(" + this.justTheUrl + ")")
  }

  constructor(private sanitizer: DomSanitizer) {
    super();
  }

  ngOnInit() {
  }
}
